import React from 'react';
import toast from 'react-hot-toast';
import { Info } from 'lucide-react';

// A message that tells the person something (for example "Upgrade to Premium to message members")
// but is not a failure, so it uses the info look (blue info icon) instead of the red error one.
export const toastInfo = (message, options = {}) => toast(message, {
    icon: <Info size={18} color="#1d6fb8" aria-hidden="true" />,
    style: { border: '1px solid #bcd9f2', background: '#f3f9ff', color: '#17496f' },
    ...options,
});

export default toastInfo;
